// extracted by mini-css-extract-plugin
export default {"saveBtn":"TermsAndConditions_saveBtn__o22+a","privacyPolicy":"TermsAndConditions_privacyPolicy__1Mt9R"};